import { CircularProgress } from "@material-ui/core";
import { COLORS } from "../../assets/theme";
import PageContainer from "../../components/PageContainer/PageContainer";
import Header from "../../components/atoms/Header";
import VehicleCard from "../../components/vehicle/VehicleCard";
import useListContainerStyles from "../../hooks/styles/useListContainerStyles";
import { useGetVehiclesQuery } from "../../redux/checklistStoreAPI";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../config/nav";
import useLastElementInfiniteScroll from "../../hooks/useLastElementInfiniteScroll";
import React from "react";

type Props = {};

const SafetyCheckVehicleListPage = (_: Props) => {
  const classes = useListContainerStyles();
  const [limit, setLimit] = React.useState<number>(10);
  const {
    data: vehicleList,
    isLoading,
    isFetching,
  } = useGetVehiclesQuery({
    page: 1,
    take: limit,
    dayLeft: 30,
  });
  const loading = isLoading || isFetching;
  const navigate = useNavigate();
  const lastElementRef = useLastElementInfiniteScroll({
    isFetching,
    page: 1,
    meta: vehicleList?.meta,
    setLimit,
    limit,
  });
  return (
    <PageContainer
      headerNavigationContent={
        <Header
          backButtonOnClick={() => navigate(ROUTES.admin)}
          showBackButton
          title={`Daftar Kendaraan`}
        />
      }
      className={classes.container}
      withBackground
    >
      <div className={classes.listContainer} style={{ minHeight: "100vh" }}>
        <>
          {vehicleList?.entities?.map((vehicle) => {
            return (
              <div ref={lastElementRef} key={vehicle.internal_id}>
                <VehicleCard vehicleData={vehicle} />
              </div>
            );
          })}
        </>
        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress
              size={18}
              color="inherit"
              style={{ color: COLORS.blue_1 }}
            />
          </div>
        )}
        {!vehicleList || vehicleList?.entities?.length === 0 ? (
          <div style={{ textAlign: "center", width: "100%" }}>
            <span>Tidak ada kendaraan yang ditemukan</span>
          </div>
        ) : null}
      </div>
    </PageContainer>
  );
};

export default SafetyCheckVehicleListPage;
